// extracted by mini-css-extract-plugin
module.exports = {"loader":"va","smallLoader":"wa","loading-keyframes":"xa","pageLoader":"ya","centered":"za","whitespacePlaceholder":"Aa","buttonSpinner":"Ba","fade-in":"Ca","rotate":"Da"};